import type { QueryClient } from "@tanstack/react-query";

const pending = new WeakMap<QueryClient, { dirty: boolean }>();

/** Coalesce refreshes without cancelling reads or accepting pre-write data as fresh. */
export function refreshRpcQueries(client: QueryClient) {
  const current = pending.get(client);
  if (current) {
    current.dirty = true;
    return;
  }
  const state = { dirty: true };
  pending.set(client, state);
  void (async () => {
    try {
      while (state.dirty) {
        state.dirty = false;
        const reads = client
          .getQueryCache()
          .findAll({ queryKey: ["local-rpc"] })
          .filter((query) => query.state.fetchStatus === "fetching")
          .map((query) => query.promise);
        await client.invalidateQueries({
          queryKey: ["local-rpc"],
          refetchType: "none",
        });
        await Promise.allSettled(reads);
        await client.invalidateQueries(
          { queryKey: ["local-rpc"] },
          { cancelRefetch: false },
        );
      }
    } finally {
      pending.delete(client);
    }
  })().catch(() => {
    /* Query error state remains available to the page. */
  });
}
